const doc = [({"en":({"js":({"buttons":({"table_expand":({"expand":"Expand"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;